// extracted by mini-css-extract-plugin
export default {"title":"Hint_title__EAKWi","text":"Hint_text__g9Jyh"};